import {ChangeDetectionStrategy, Component, Input, output} from '@angular/core';

import {TranslatePipe} from '@brunata-angular/util';
import {ConsumptionCardComponent} from './consumption-card/consumption-card.component';
import {ConsumptionAgentTranslated} from '../consumption-agent.model';
import {EditAgentEvent} from '../consumption-agent-table/consumption-agent-overview.model';

@Component({
    selector: 'app-consumption-card-view',
    standalone: true,
    imports: [TranslatePipe, ConsumptionCardComponent],
    templateUrl: './consumption-card-view.component.html',
    styleUrl: './consumption-card-view.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsumptionCardViewComponent {
    @Input() consumptionAgents: ConsumptionAgentTranslated[] = [];
    @Input() buildingNo: string | undefined;

    editConsumptionAgent = output<EditAgentEvent>();
    duplicateConsumptionAgent = output<string>();
    deleteConsumptionAgent = output<{reportId: string; agentName: string}>();

    editAgent(reportId: string, agentName: string): void {
        this.editConsumptionAgent.emit({reportId, agentName});
    }

    duplicateAgent(reportId: string): void {
        this.duplicateConsumptionAgent.emit(reportId);
    }

    deleteAgent(reportId: string, agentName: string): void {
        this.deleteConsumptionAgent.emit({reportId, agentName});
    }
}
